// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"9e6dfcd1","382":"d95710b3","453":"2d152c58"}[chunkId] + ".chunk.js";
};